






import { Component, Vue } from "vue-property-decorator";
import { AppContainer, TYPES } from "@/app/index";
import AppointmentInformation from "@/components/entities/AppointmentInformation/AppointmentInformation.vue"; // @ is an alias to /src

@Component({
  components: {
    AppointmentInformation
  }
})
export default class Appointment extends Vue {
}
